<template>
    <admin-breadcrumbs>
        <li class="breadcrumb-item">
            <router-link to="/admin/series/">
                Series
            </router-link>
        </li>

        <li class="breadcrumb-item">
            <router-link :to="`/admin/lessons/${$route.params.id}/edit`">
                Lesson
            </router-link>
        </li>

        <li class="breadcrumb-item active">
            Components
        </li>
    </admin-breadcrumbs>

    <div class="card card-default">

        <div class="card-header">
            Lesson Components

            <template v-if="$app.canAdministrate">
                <a
                    :href="`/admin/lessons/${$route.params.id}/edit/`"
                    class="btn btn-primary btn-sm float-end"
                >
                    Edit Lesson
                </a>

                <router-link
                    :to="`/admin/components/create/?lesson_id=${$route.params.id}`"
                    class="btn btn-success btn-sm float-end"
                >
                    Create Component
                </router-link>
            </template>
        </div>

        <div class="card-body">

            <components-table
                endpoint="/admin/api/components"
                :filters="{
                    'lesson_id': $route.params.id,
                }"
            />

        </div>

    </div>
</template>

<script>
import ComponentsTable from "../../../admin/ComponentsTable.vue";
import AdminBreadcrumbs from "../../../partials/AdminBreadcrumbs.vue";

export default {
    name: "LessonShow",

    components: {
        AdminBreadcrumbs,
        ComponentsTable,
    },
};
</script>
